import { createAction } from 'typesafe-actions';
import { IPumpingStationPumpMake } from '../../../../@types/model/masterData/pumpingStation/pumpMake';

export default class MasterDataPumpingStationPumpMakeActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_PUMP_MAKES', resolve => (pumps : Array<IPumpingStationPumpMake>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_PUMP_MAKES_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}